import { z } from "zod";
export const ApplicationSettingsSchema = z.object({
    appPreviewJWTTimeoutSeconds: z.number().default(3600)
});
